<ta-modal [showCloseIcon]="data.dismissable">
  <ng-template taModalLeading>
    <ta-modal-leading-icon [appearance]="data.iconColor ?? 'info'" [icon]="data.icon"></ta-modal-leading-icon>
  </ng-template>
  <ng-template taModalHeading>
    {{data.title|translate}}
  </ng-template>
  <ng-template taModalSubHeading>
    {{data.subtitle ||''|translate}}
  </ng-template>
  <ng-template taModalBody>
    <div class="tsc-rich-text" [innerHTML]="data.description|translate|taDomSanitizer:'html'"></div>
  </ng-template>
  <ng-template taModalFooter>
    <ta-button taModalClose appearance="outline" size="lg" color="neutral">{{data.dismissLabel|translate}}</ta-button>
    <ta-button taModalClose [dataOnClose]="true" size="lg" color="danger">{{data.okLabel|translate}}</ta-button>
  </ng-template>
</ta-modal>
